export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"Malt allows you to find the best developers, designers, content writers, marketers and also helps you simplify contracts, payments, and other administrative paperwork."},{"name":"format-detection","content":"telephone=no"},{"name":"twitter:card","content":"summary"},{"name":"twitter:image","content":"https://dam.malt.com/rebranding2020/malt-logo/malt-banner-logo"},{"name":"twitter:title","content":"Malt"},{"name":"twitter:description","content":"Malt allows you to find the best developers, designers, content writers, marketers and also helps you simplify contracts, payments, and other administrative paperwork."},{"property":"og:type","content":"website"},{"property":"og:image","content":"https://dam.malt.com/rebranding2020/malt-logo/malt-banner-logo"},{"property":"og:title","content":"Malt"},{"property":"og:description","content":"Malt allows you to find the best developers, designers, content writers, marketers and also helps you simplify contracts, payments, and other administrative paperwork."}],"link":[{"rel":"preconnect","href":"//dam.malt.com"},{"rel":"preconnect","href":"//www.googletagmanager.com"},{"rel":"icon","sizes":"32x32","href":"//dam.malt.com/favicon.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"//dam.malt.com/mobile/apple-touch-icon-76x76.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"//dam.malt.com/mobile/apple-touch-icon-120x120.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"//dam.malt.com/mobile/apple-touch-icon-152x152.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"//dam.malt.com/mobile/apple-touch-icon-180x180.png"},{"href":"https://cdn.malt.com/npm/@maltjoy/themes/fonts/moderat/moderat-regular-webfont.woff2","rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"href":"https://cdn.malt.com/npm/@maltjoy/themes/fonts/moderat/moderat-bold-webfont.woff2","rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"href":"https://cdn.malt.com/npm/@maltjoy/themes/fonts/agrandir/agrandir-tightmedium-webfont.woff2","rel":"preload","as":"font","type":"font/woff2","crossorigin":"anonymous"}],"style":[],"script":[{"src":"https://cdnjs.cloudflare.com/polyfill/v3/polyfill.min.js?features=globalThis%2CObject.fromEntries%2CArray.prototype.flatMap%2CString.prototype.replaceAll%2CPromise.allSettled%2CResizeObserver%2CArray.prototype.toSorted%2CArray.prototype.toReversed","defer":true},{"type":"importmap","async":true,"innerHTML":"{\"imports\":{\"vue\":\"https://cdn.malt.com/nuxt/1.0.0/vendors-Cp-lvvFf.js\",\"vue-router\":\"https://cdn.malt.com/nuxt/1.0.0/vendors-Cp-lvvFf.js\",\"pinia\":\"https://cdn.malt.com/nuxt/1.0.0/vendors-Cp-lvvFf.js\"},\"integrity\":{\"https://cdn.malt.com/nuxt/1.0.0/vendors-Cp-lvvFf.js\":\"sha384-RM1iRc9Byh63pZfsnAP4Y7rWnJsIyKrxJR4YGMkfTgQqWRQY+FLS/XWCTGCQbebp\"}}","tagPosition":"head","tagPriority":"critical"},{"src":"https://cdn.malt.com/nuxt/1.0.0/es-module-shims.js","async":true,"tagPosition":"head","tagPriority":"critical"},{"type":"module","async":true,"src":"https://cdn.malt.com/nuxt/1.0.0/vendors-Cp-lvvFf.js","tagPosition":"head","tagPriority":"critical","integrity":"sha384-RM1iRc9Byh63pZfsnAP4Y7rWnJsIyKrxJR4YGMkfTgQqWRQY+FLS/XWCTGCQbebp","onerror":"\n                const pathname = window.location.pathname;\n                if (!pathname) {\n                    return window.location.href = '/custom-error-redirection';\n                }\n                \n                window.location.href = '/custom-error-redirection/' + '?origin=' + pathname;\n            "}],"noscript":[],"title":"Malt"}

export const appBaseURL = "/sitemap"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"prefetch":false,"componentName":"NuxtLink","prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false